// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeFanFollowFollowersListBody = {
  cursor?: string | null;
  limit?: number | null;
};

export type typeFanFollowFollowersListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      accountId: string;
      username: string;
      displayName: string;
      photoUrl?: string | null;
      followedAt: string;
      followState: "none" | "requested" | "following";
    }[];
    nextCursor?: string | null;
  };
};

export type typeFanFollowFollowersListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowFollowersListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowFollowersListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaFanFollowFollowersListBody = {
  type: "object",
  properties: {
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createFanFollowFollowersList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaFanFollowFollowersListBody);
  }

  return async function postFanFollowFollowersList(
    payload: typeFanFollowFollowersListBody,
  ): Promise<
    typeFanFollowFollowersListOutput200 | typeFanFollowFollowersListOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postFanFollowFollowersList" failed before calling the network. #55b7d7be383f`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#55b7d7be383f" },
        },
        data: null,
      } as typeFanFollowFollowersListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/fan-follow/followers-list`,
      httpMethod: "POST",
      options,
    })) as
      typeFanFollowFollowersListOutput200 | typeFanFollowFollowersListOutput400;
  };
}
